import { Box } from "@mui/material";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TbArrowsMaximize, TbArrowsMinimize, TbRefresh } from "react-icons/tb";

import FilterButton from "@/components/table/FilterButton";
import DriverFilter from "@/pages/Plannn/components/table/PlanDriverFilter";
import { IHotelPlanningDepartureResponseItem } from "@/schemas/hotelPlanningDepartureSchema";
import {
    useHotelPlanningDepartureActions,
    useHotelPlanningDepartureFilterField,
    useHotelPlanningDepartureIsFullScreen,
} from "@/stores/use-hotel-planning-departure-table";

const HotelDepartureToolbar = memo(function CustomToolbar({
    reloadTable,
    allRows,
}: {
    reloadTable: () => void;
    allRows: IHotelPlanningDepartureResponseItem[];
}) {
    const { t } = useTranslation();

    const isFullScreen = useHotelPlanningDepartureIsFullScreen();
    const { updateFullScreen, updateFilters } = useHotelPlanningDepartureActions();
    const selectedDrivers = useHotelPlanningDepartureFilterField("selectedDrivers");

    const handleDriverChange = useCallback(
        (driverIds: string[]) => {
            updateFilters({
                selectedDrivers: driverIds,
            });
        },
        [updateFilters]
    );
    const getDriverId = useCallback((row: IHotelPlanningDepartureResponseItem) => row.assignedUser?.userId || "", []);

    return (
        <GridToolbarContainer className="!flex !flex-nowrap !items-center !px-2 !py-1 !gap-1">
            <GridToolbarQuickFilter placeholder={t("search") + " ..."} />
            <Box sx={{ flexGrow: 1 }} />
            <DriverFilter<IHotelPlanningDepartureResponseItem>
                allRows={allRows}
                currentDrivers={selectedDrivers}
                onDriverChange={handleDriverChange}
                disabled={false}
                getDriverId={getDriverId}
                driverKey="userId"
            />

            <FilterButton handleClick={() => reloadTable()} icon={TbRefresh} tooltip={t("tooltips.refreshTable")} />
            <FilterButton
                active={isFullScreen}
                handleClick={() => updateFullScreen()}
                tooltip={t("tooltips.fulscreen", { count: isFullScreen ? 2 : 1 })}
                icon={isFullScreen ? TbArrowsMinimize : TbArrowsMaximize}
            />
        </GridToolbarContainer>
    );
});

export default HotelDepartureToolbar;
